import React, { useState, useEffect, useRef } from 'react'
import { ClientsTab } from '@/components/clients/ClientsTab'
import { GroupsTab } from '@/components/clients/GroupsTab'
import { useClientsStore } from '@/stores/clients.store'
import { useGroupsStore } from '@/stores/groups.store'
import { useAuth } from '@/hooks/useAuth'
import { canManageClientGroups } from '@/utils/role-access'

export const ClientsPage: React.FC = () => {
  const fetchClients = useClientsStore(state => state.fetchClients)
  const fetchGroups = useGroupsStore(state => state.fetchGroups)
  const { user } = useAuth()
  const showTabs = canManageClientGroups(user)
  const [activeTab, setActiveTab] = useState<'clients' | 'groups'>('clients')
  const hasFetchedRef = useRef(false)

  // Fetch clients and groups once on mount
  useEffect(() => {
    if (hasFetchedRef.current) return
    hasFetchedRef.current = true

    Promise.all([fetchClients(), fetchGroups()]).catch(error => {
      console.error('Error loading data:', error)
    })
  }, [fetchClients, fetchGroups])

  return (
    <div>
      {/* Tabs */}
      {showTabs && (
        <div className="border-b border-[var(--color-border)] mb-6">
        <nav className="flex space-x-8">
          <button
            onClick={() => setActiveTab('clients')}
            className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
              activeTab === 'clients'
                ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
            }`}
          >
            Clients
          </button>
            <button
              onClick={() => setActiveTab('groups')}
              className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'groups'
                  ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                  : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
              }`}
            >
              Groupes
            </button>
        </nav>
      </div>)}

      {/* Tab Content */}
      {activeTab === 'clients' && <ClientsTab />}
      {activeTab === 'groups' && <GroupsTab />}
    </div>
  )
}
